import React from 'react';
import {Form, Edit, List} from 'components';
import {useNamedSelector} from 'helpers';

export function HabitsInquiry1() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'habits-inquiry-1' })}>
      <List tiny-gutter>
        <List.Title>What behaviors, choices and habits do you engage in on a regular basis, that support you in creating what you want?</List.Title>
        <Edit name="1" />
        <Edit name="2" />
        <Edit name="3" />
        <List.Title>What behaviors, choices and habits do you engage in on a regular basis, that are in direct opposition to creating what you want?</List.Title>
        <Edit name="4" />
        <Edit name="5" />
        <Edit name="6" />
        <List.Title>Which habits have been detrimental to your success in different aspects of your life?</List.Title>
        <Edit name="7" />
        <Edit name="8" />
        <Edit name="9" />
        <List.Title>Which positive habits would you like to adopt? (e.g., start a fitness program, meditating every morning, be on time, etc.)</List.Title>
        <Edit name="10" />
        <Edit name="11" />
        <Edit name="12" />
      </List>
    </Form>
  );
}
